import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import ModalForgotPassword from "../ModalForgotPassword/ModalForgotPassword";
import { cpfMask, phoneNumberMask, patternOnlyNumbers, cnpjMask } from "../utils/masks";
import { getUserToken } from "../../../js/shared/utils";
import jwt_decode from "jwt-decode";
import InputForm from "../../atoms/InputForm";
import Callout from "../Callout/Callout";
import ModalLatamPhone from "../ModalPhoneLatam/ModalLatamPhone";
import {
	GOL_ACRONYM,
	GOL_FIDELITY_PROGRAM,
	Type2FA,
	GOL_TWO_FACTOR_MESSAGE
} from "../../../../js/shared/constants";
import Radio from "../../Radio/Radio";
import ButtonLink from "../../../../js/components/DynamicForm/components/ButtonLink";
import ModalPhoneTwoFactorAuthentication from "../ModalPhoneTwoFactorAuthentication/ModalPhoneTwoFactorAuthentication";
import Button from "../../button/button";

// Máximo de caracteres para senha da Smiles
const maxLengthPassSmiles = 4;

// Máximo de caracteres para senha da LatamPass(aniga Multiplus)
const maxLengthPassMultiplus = 5;

// Debounce function
let timerId;
let fnWaiting;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	if (!fn && fnWaiting) fnWaiting();
	fnWaiting = fn;
	if (!fn) return;
	timerId = setTimeout(fn, delay);
};

class BoxFidelityProgramDetails extends Component {
	constructor() {
		super();
		this.state = {
			user: "",
			lastName: "",
			password: "",
			pwAwardSecondary: "",
			phone: "",
			twoFactorAuthenticationStrategy: "",
			showModalTwoFactorAuthenticationPhone: false,
			isMaxPhone: false,
			forgotPassword: false,
			showModalPhone: false,
			errors: [],
			international: false,
			isInternationalCpfError: false,
			debouncing: false
		};
		this.onChange = this.onChange.bind(this);
		this.onChangeRadio = this.onChangeRadio.bind(this);
		this.updateTwoFactorAuthenticationWhenAlreadyRegistered = this.updateTwoFactorAuthenticationWhenAlreadyRegistered.bind(this);
		this.setInfos = this.setInfos.bind(this);
		this.checkAllFilled = this.checkAllFilled.bind(this);
		this.requestTwoFactorCode = this.requestTwoFactorCode.bind(this);
	}

	setInfos(name, value) {
		this.setState({ [name]: value });
	}

	checkAllFilled(state = this.state) {
		const { checkData, fidelityProgram, status2FAEnabledFeature } = this.props;
		const {
			user,
			password,
			pwAwardSecondary,
			phone,
			twoFactorAuthenticationStrategy,
			errors,
			lastName,
			debouncing
		} = state;

		let fieldsIsCompleted = true;

		if (fidelityProgram.id === 3) {
			fieldsIsCompleted =
				pwAwardSecondary.length === maxLengthPassMultiplus &&
				!!phone.length &&
				!errors.pwAwardSecondary &&
				!errors.phone &&
				!debouncing;
		}

		if (fidelityProgram.id === 14) {
			fieldsIsCompleted = !!lastName.length && !debouncing;
		}

		if (fidelityProgram.id === GOL_FIDELITY_PROGRAM && status2FAEnabledFeature) {
			fieldsIsCompleted = !!twoFactorAuthenticationStrategy.length && !errors.twoFactorAuthenticationStrategy && !debouncing;
		}

		fieldsIsCompleted =
			fieldsIsCompleted &&
			!!user.length &&
			!!password.length &&
			!errors.user &&
			!errors.password &&
			!debouncing;

		checkData("completedBoxDataFidelityProgramDetails", fieldsIsCompleted);
	}

	componentWillMount() {
		const { fidelityProgram, userData, setData } = this.props;
		const { errors } = this.state;

		let boolInternational = fidelityProgram.international === "1";
		let user;
		let token = getUserToken();
		let payload = jwt_decode(token);

		if (!boolInternational) {
			user = payload.ssn
				.match(patternOnlyNumbers)
				.join("")
				.toString();
			setData({ user: user });
		} else {
			user = userData.username ? userData.username : "";
			setData({ user: user });
		}

		let password = userData.password ? userData.password : "";
		let pwAwardSecondary = userData.pwAwardSecondary ? userData.pwAwardSecondary : "";
		let phone = userData.phone ? userData.phone : "";
		let lastName = fidelityProgram.id === 14 ? userData.lastName : null;
		let twoFactorAuthenticationStrategy = this.state.twoFactorAuthenticationStrategy ? this.state.twoFactorAuthenticationStrategy : "";

		this.setState({
			user: user,
			password: password,
			pwAwardSecondary: pwAwardSecondary,
			phone: phone,
			isMaxPhone: userData.isMaxPhone,
			international: boolInternational,
			lastName,
			twoFactorAuthenticationStrategy: twoFactorAuthenticationStrategy,
			errors: {
				...errors,
				pwAwardSecondary: !!pwAwardSecondary && pwAwardSecondary.length !== maxLengthPassMultiplus
			}
		});

		// Se for Latam Pass e, existir senha resgate
		// e a senha de resgate não for apenas números ou diferente de 5 dígitos:
		// Insere pwAwardSecondary: true na lista de erros
		if (
			fidelityProgram.id === 3 &&
			pwAwardSecondary.length > 0 &&
			(!/^\d+$/.test(pwAwardSecondary) || pwAwardSecondary.length !== 5)
		) {
			this.setState({ errors: { ...errors, pwAwardSecondary: true } });
		}

		if (fidelityProgram.id === GOL_FIDELITY_PROGRAM && !twoFactorAuthenticationStrategy.length) {
			this.setState({ errors: { ...errors, twoFactorAuthenticationStrategy: true } });
		}

		setTimeout(() => this.checkAllFilled(), 200);
	}

	componentWillUpdate(nextProps, nextState) {
		if (!nextState.debouncing && this.state.debouncing) {
			this.checkAllFilled(nextState);
		}
	}

	onChangePhone(value, phoneField) {
		const { errors } = this.state;
		const { setData, phoneMMSuggestion, fidelityProgram } = this.props;
		let phone = value.match(patternOnlyNumbers)
			? value
				.match(patternOnlyNumbers)
				.join("")
				.toString()
			: "";
		let isMaxPhone = phone === phoneMMSuggestion ? 1 : 0;
		this.setState({
			[`${phoneField}`]: value,
			isMaxPhone,
			errors: { ...errors, phone: false },
			debouncing: true
		});

		debounced(
			() =>
				this.setState({
					errors: { ...errors, phone: phone.length !== 11 || phone[2] !== "9" },
					debouncing: false
				}),
			1000
		);
		setData({
			[`${phoneField}`]: phone,
			isMaxPhone
		});
	}

	updateTwoFactorAuthenticationWhenAlreadyRegistered = type => {
		const { setData } = this.props;
		const { errors, user } = this.state;
		const { value } = type;

		this.setState({ twoFactorAuthenticationStrategy: value, errors: { ...errors, twoFactorAuthenticationStrategy: !value.length } });
		setData({ user: user, twoFactorAuthenticationStrategy: value });
		setTimeout(() => this.checkAllFilled(), 200);
	};

	onChangeRadio = event => {
		const { setInputInFocus, setData } = this.props;
		const { errors } = this.state;
		const { value } = event;
		setInputInFocus("twoFactorAuthenticationStrategy");
		if (value === Type2FA.WHATSAPP_CONTACT) {
			this.setState({ showModalTwoFactorAuthenticationPhone: true });
		}
		this.setState({ twoFactorAuthenticationStrategy: value, errors: { ...errors, twoFactorAuthenticationStrategy: !value.length } });
		setData({ twoFactorAuthenticationStrategy: value });
		setTimeout(() => this.checkAllFilled(), 200);
	};

	onChange = event => {
		const { name, value } = event.target;
		const { international, errors } = this.state;
		const { fidelityProgram, setData } = this.props;
		let token = getUserToken();
		let payload = jwt_decode(token);
		switch (name) {
			case "user":
				let user = international
					? value
					: payload.ssn
						.match(patternOnlyNumbers)
						.join("")
						.toString();
				international && this.setState({ user: user, errors: { ...errors, user: !value.length } });
				international &&
					(value == payload.ssn ||
						value ==
						payload.ssn
							.match(patternOnlyNumbers)
							.join("")
							.toString()) // Verifica se o user é igual ao CPF com ou sem máscara
					? this.setState({ isInternationalCpfError: true, errors: { ...errors, user: true } })
					: this.setState({ isInternationalCpfError: false });
				setData({ [name]: user });
				break;
			case "lastName":
				let lastName = String(value).replace(/[0-9]/g, "");

				international &&
					this.setState({ lastName: lastName, errors: { ...errors, lastName: !value.length } });
				setData({ [name]: lastName });
				break;
			case "password":
				let password = value;
				if (fidelityProgram.id === 4) {
					password = value.match(patternOnlyNumbers)
						? value.match(patternOnlyNumbers).toString()
						: "";
					this.setState({
						password: password,
						errors: { ...errors, password: false },
						debouncing: true
					});
					debounced(
						() =>
							this.setState({
								errors: { ...errors, password: password.length !== maxLengthPassSmiles },
								debouncing: false
							}),
						1000
					);
				} else {
					this.setState({
						password: password,
						errors: { ...errors, password: false },
						debouncing: true
					});
					debounced(
						() =>
							this.setState({
								errors: { ...errors, password: !password.length || password.length < 3 },
								debouncing: false
							}),
						1000
					);
				}
				setData({ [name]: password });
				break;
			case "pwAwardSecondary":
				let pwAwardSecondary = value.match(patternOnlyNumbers)
					? value.match(patternOnlyNumbers).toString()
					: "";
				this.setState({
					pwAwardSecondary: pwAwardSecondary,
					errors: { ...errors, pwAwardSecondary: false },
					debouncing: true
				});
				debounced(
					() =>
						this.setState({
							errors: {
								...errors,
								pwAwardSecondary: pwAwardSecondary.length !== maxLengthPassMultiplus
							},
							debouncing: false
						}),
					1000
				);
				setData({ [name]: pwAwardSecondary });
				break;
			case "phone":
				this.onChangePhone(value, "phone");
				break;
		}

		setTimeout(() => this.checkAllFilled(), 200);
	};

	requestTwoFactorCode = async () => {
		const { request2FACodeLatam, setHasClickedRequest2FACode } = this.props;
		setHasClickedRequest2FACode(true);
		await request2FACodeLatam();
	};

	render() {
		const {
			setInputInFocus,
			inputInFocus,
			phoneMMSuggestion,
			fidelityProgram,
			airlineProgramsSettings,
			email2FAStatusValidation,
			offerData,
			status2FAEnabledFeature,
			hasClickedRequest2FACode,
			hasTriedToProceedWithout2FA,
			twoFactorData
		} = this.props;
		const typePhoneLatam = fidelityProgram.phoneRequiredMode;
		const { id, fidelityName, linkPasswordRecovery } = this.props.fidelityProgram;

		const golAirlineProgramsSettings =
			airlineProgramsSettings &&
			Object.values(airlineProgramsSettings).find(
				item => item.idAirlinesProgram === GOL_FIDELITY_PROGRAM
		);

		const {
			user,
			lastName,
			password,
			pwAwardSecondary,
			phone,
			isMaxPhone,
			international,
			forgotPassword,
			showModalPhone,
			errors,
			isInternationalCpfError,
			twoFactorAuthenticationStrategy,
			showModalTwoFactorAuthenticationPhone
		} = this.state;
		const ruleMaskInputUser = international ? undefined : user.length <= 11 ? cpfMask : cnpjMask;

		const shouldShow2FAButton = twoFactorData?.is2FAEnabled;

		return (
			<div className="box-fidelity-program-details">
				<p className="box-fidelity-program-details--title box-title">Dados da {fidelityName}</p>
				<form>
					<div className="row box-fidelity-program-details--row">
						<div className="col-xs-16">
							<InputForm
								name="user"
								id="user"
								value={user}
								onChange={this.onChange}
								mask={ruleMaskInputUser}
								onFocus={() => setInputInFocus("user")}
								placeholder=""
								disabled={!international}
								label={`${international ? "Usuário" : "CPF do titular"}`}
								hasError={errors.user}
								errorMessage={
									isInternationalCpfError &&
									"Nas companhias internacionais, o cadastro do usuário é diferente do número do CPF."
								}
							/>
						</div>
						{id == 14 && (
							<div className="col-xs-16">
								<InputForm
									name="lastName"
									id="lastName"
									value={lastName}
									onChange={this.onChange}
									onFocus={() => setInputInFocus("user")}
									placeholder=""
									disabled={!international}
									label="Sobrenome"
									hasError={errors.lastName}
								/>
							</div>
						)}
						<div className="col-xs-8">
							<InputForm
								autoComplete={international ? "new-password" : undefined}
								name="password"
								id="password"
								type="password"
								autocomplete="off"
								value={password}
								inputMode={id === 4 ? "tel" : undefined}
								maxLength={50}
								onChange={this.onChange}
								onFocus={() => setInputInFocus("password")}
								onBlur={() => debounced(null)}
								placeholder=""
								label="Senha de acesso"
								hasError={errors.password}
								errorMessage={`Senha inválida. ${id === 4
									? `A senha de acesso tem ${maxLengthPassSmiles} números.`
									: "O número de caracteres é insuficiente."
									}`}
								helperText={
									<CSSTransition
										in={inputInFocus === "password" && !!linkPasswordRecovery}
										unmountOnExit
										timeout={200}
										classNames="box-fidelity-program-details--forgot-password"
									>
										<div className="box-fidelity-program-details--forgot-password">
											<a
												onClick={() => this.setState({ forgotPassword: true })}
												data-action="forgot-password"
											>
												Esqueci minha senha
											</a>
										</div>
									</CSSTransition>
								}
								data-action="login-offer-password"
							/>

							{shouldShow2FAButton && (
								<div className="form-group">
									<Button
										onClick={this.requestTwoFactorCode}
										disabled={hasClickedRequest2FACode || !user || !password}
										className="btn-gray-md-o"
										type="button"
									>
										{twoFactorData.button?.text}
									</Button>
									<CSSTransition
										in={hasClickedRequest2FACode || hasTriedToProceedWithout2FA}
										unmountOnExit
										classNames="box-fidelity-program-details"
									>
										<div className="box-fidelity-program-details">
											<span
												className={
													hasClickedRequest2FACode
														? ""
														: "box-fidelity-program-details--error-message"
												}
											>
												{hasClickedRequest2FACode
													? twoFactorData.helpTextAfterClickButton
													: twoFactorData.helpTextBeforeClickButton}
											</span>
										</div>
									</CSSTransition>
								</div>
							)}
						</div>

					</div>
					{id === GOL_FIDELITY_PROGRAM && golAirlineProgramsSettings && status2FAEnabledFeature && (
						<div className={`box-2fa`}>
							<p className="box-2fa--title box-title">{golAirlineProgramsSettings.title}</p>
							{golAirlineProgramsSettings.options.map(item => {
								!twoFactorAuthenticationStrategy && item.selected && this.updateTwoFactorAuthenticationWhenAlreadyRegistered({ value: item.type })
								return <div className="row box-2fa__box-radio" key={item.type}>
									<div className="col">
										<p className="box-2fa--paragraph">{item.title} {item.tags.length > 0 && (<span className="box-2fa__badge">{item.tags}</span>)}</p>
										<Radio
											horizontally={false}
											options={[{ value: item.type, label: item.description, checked: !twoFactorAuthenticationStrategy && item.selected || twoFactorAuthenticationStrategy === item.type }]}
											name="twoFactorAuthenticationStrategy"
											value={twoFactorAuthenticationStrategy}
											onChange={this.onChangeRadio}
											errorMessage={errors.twoFactorAuthenticationStrategy}
										/>
										{item.actions?.length > 0 && (
											<div className="box-2fa__box-radio--small-font">
												{!item.actions[0]?.disabled && (
													<Callout
														show={!twoFactorAuthenticationStrategy && item.selected || twoFactorAuthenticationStrategy === item.type}
														hideIcon={true}
														style={{ borderTop: '1px solid #E2E8F0' }}
														text={
																<div className="row height-auto width-100">
																	<div><span>{item.actions[0]?.text} <a className="green-primary-color" href={item.actions[0]?.link} target="_blank">{item.actions[0]?.textLink}</a></span></div>
																	{!item.actions[1]?.disabled && (
																		<div className="no-padding-left col-xs-8 mb-16 mt-16 link-text-decoration-none">
																			{item.actions[1]?.link && item.actions[1]?.textLink && (
																				<ButtonLink
																					color="green"
																					onClick={() =>
																						(window.open().location.href = item.actions[1].link)
																					}
																				>
																					{item.actions[1].textLink}
																				</ButtonLink>
																			)}
																		</div>
																	)}
																	{!item.actions[2]?.disabled && (
																		<div className={`no-padding-right col-xs-8 mb-16 mt-16 link-text-decoration-none `}>
																			{item.actions[2]?.link && item.actions[2]?.textLink && ((!email2FAStatusValidation.isValidated && email2FAStatusValidation.error !== null) || (offerData.data.quant >= item.actions[2]?.minPointsToAlwaysShowButton)) && (
																				<ButtonLink color="green" buttonStyle="outline" onClick={() => window.open().location.href = item.actions[2].link}>{item.actions[2].textLink}</ButtonLink>
																			)}
																		</div>
																	)}
																</div>
														}
													/>
												)}
												{!item.actions[1]?.disabled && (
													<>
														{item.actions[1]?.text && (
															<Callout
																show={!twoFactorAuthenticationStrategy && item.selected || twoFactorAuthenticationStrategy === item.type}
																hideIcon={true}
																style={{ borderTop: '1px solid #E2E8F0' }}
																text={
																	<span>{item.actions[1]?.text}</span>
																}
															/>
														)}
													</>
												)
												}
											</div>
										)}
									</div>
								</div>
							})}
						</div>
					)}
					{id === 3 && typePhoneLatam !== 1 && (
						<>
							<div className="row box-fidelity-program-details--row">
								<div className="col-xs-16">
									<InputForm
										name="phone"
										id="phone"
										value={phone}
										type="tel"
										onChange={this.onChange}
										onFocus={e => {
											if (typePhoneLatam === 0 && !phone) {
												this.setInfos("showModalPhone", true);
											}
											setInputInFocus("phone");
										}}
										onBlur={() => debounced(null)}
										placeholder=""
										mask={phoneNumberMask}
										label="Telefone no Latam Pass"
										hasError={typePhoneLatam === 0 && errors.phone}
										errorMessage={typePhoneLatam === 0 && "Número de celular inválido"}
										data-action="login-offer-phone"
										helperText={
											phone &&
											isMaxPhone == 1 &&
											typePhoneLatam === 0 && (
												<div className="box-fidelity-program-details--phone-chek">
													<i className="icon-check" />
													<p>Telefone confirmado</p>
												</div>
											)
										}
									/>
									<Callout
										show={phone && isMaxPhone == 0 && typePhoneLatam === 0}
										criticalWarn
										text={
											<span>
												Atenção! É obrigatório adicionar o número de telefone celular da MaxMilhas
												no seu cadastro Latam Pass. Para alterar,{" "}
												<a onClick={() => this.setState({ showModalPhone: true })}>clique aqui</a>
												{"."}
											</span>
										}
									/>
									<Callout
										show={phone && isMaxPhone == -1 && typePhoneLatam === 0}
										criticalWarn
										text={
											<span>
												Este número foi desativado e deve ser alterado para outro telefone indicado
												pela MaxMilhas. Para alterar,{" "}
												<a onClick={() => this.setState({ showModalPhone: true })}>clique aqui</a>
											</span>
										}
									/>
								</div>
							</div>
						</>
					)}
				</form>
				<ModalForgotPassword
					linkPasswordRecovery={linkPasswordRecovery}
					show={forgotPassword}
					closeModal={this.setInfos}
				/>
				<ModalLatamPhone
					show={showModalPhone}
					close={() => this.setInfos("showModalPhone", false)}
					confirm={value => {
						this.setInfos("showModalPhone", false);
						this.onChangePhone(value);
					}}
					phoneSugestion={phoneMMSuggestion}
					phone={phone}
				/>
				<ModalPhoneTwoFactorAuthentication
					show={showModalTwoFactorAuthenticationPhone}
					onConfirm={() => this.setState({ showModalTwoFactorAuthenticationPhone: false })}
				/>
			</div>
		);
	}
}

BoxFidelityProgramDetails.propTypes = {
	checkData: PropTypes.func,
	fidelityProgram: PropTypes.object.isRequired,
	inputInFocus: PropTypes.string,
	setData: PropTypes.func,
	setInputInFocus: PropTypes.func,
	userData: PropTypes.object.isRequired,
	phoneMMSuggestion: PropTypes.string,
	typePhoneLatam: PropTypes.number
};

export default BoxFidelityProgramDetails;
